module.exports = __webpack_public_path__ + "img/ios-share.53e954a8.svg";